<template>
    <div class="user-register">
        <h4 style="text-align: center;margin-bottom: 30px">用户微信公众号注册</h4>
        <!-- <mt-field label="*登录账号" type="number" :attr="{ maxlength: 11 }" @keyup.enter.native.capture="userRegisterClick()" placeholder="请输入手机号" v-model="userInfo.AgentName"></mt-field> -->
        <mt-field label="*联系电话" type="number" :attr="{ maxlength: 11 }" @keyup.enter.native.capture="userRegisterClick()" placeholder="请输入手机号" v-model="userInfo.Phone"></mt-field>
        <mt-field label="*联系人姓名" @keyup.enter.native.capture="userRegisterClick()" placeholder="请输入真实姓名" v-model="userInfo.Linkman"></mt-field>
        <!-- <mt-field label="*可联系地址" @keyup.enter.native.capture="userRegisterClick()" placeholder="请输入可联系地址" v-model="userInfo.Address"></mt-field> -->
        <!-- <mt-field label="*代理区域" :disabled=true @click.native.capture="select()" placeholder="点击选择代理区域" type="text"></mt-field> -->
        <!-- <a class="mint-cell mint-field">
            <div class="mint-cell-left"></div>
            <div class="mint-cell-wrapper">
                <div class="mint-cell-title">
                    <span class="mint-cell-text">*代理区域</span>
                </div>
                <div class="mint-cell-value" style="background-color: rgb(235, 235, 228);line-height: 1.6;color: #888;cursor: pointer;" @click="select()">
                    <span v-for="item in userInfo.AreaList" :key="item.id" style="padding-right: 10px;">
                        <span style="padding-right: 5px;">{{item.value}}</span>
                        <i @click.stop="deleteAddress(item)" class="fa fa-close"></i>
                    </span>
                    <span v-if="userInfo.AreaList.length == 0">点击选择代理区域</span>
                </div>
            </div>
            <div class="mint-cell-right"></div>
        </a> -->
        <mt-field label="邀请码" @keyup.enter.native.capture="userRegisterClick()" placeholder="请输入邀请码" v-model="userInfo.InvitationCode"></mt-field>
        <yz-select v-if="show" :ref="show" @changeValue='isShow' :province='province' :city='city' :county='county'></yz-select>
        <mt-button class="submit-btn" size="large" type="primary" @click.native="userRegisterClick()">注册</mt-button>
    </div>
</template>

<script>
// import select from '@/components/select'
export default {
//   components:{
//     'yz-select': select
//   },
  data() {
    return {
        codeValue: '获取验证码',
        validCode: true,
        show: false,
        address: '',
        province: '',
        city: '',
        county: '',
        userInfo: {
            Password: 123456,
            AgentName: '',
            Linkman: '',
            Phone: '',
            Address: '',
            InvitationCode: '',
            AreaList: [ ],
            Code: '',
        },
        requestUrl: 'https%3a%2f%2fagent.product.52bkb.com%2f%23%2f'
    }
  },
  methods: {
    select(){ this.show = true },
    isShow(msg){
        let _this = this;
        // console.log(msg);
        _this.show = msg.show;
        _this.address = msg.result;
        _this.province = msg.province;
        _this.city = msg.city;
        _this.county = msg.county;
        if(msg.lastcityobj) {
            let arr = _this.userInfo.AreaList;
            for (let index = 0; index < arr.length; index++) {
                if(arr[index].AreaID == msg.lastcityobj.id){
                    return;
                }
            }
            _this.userInfo.AreaList.push({
                AreaID: msg.lastcityobj.id,
                AreaName: _this.address,
                value: _this.address
            })
        }
    },
    getCode(){
        var time=60;
        var that = this;
        if(this.validCode){
            this.validCode = false;
            this.codeValue =  time + '秒';
            var t = setInterval(getTime,1000)
        }
        function getTime(){
            time--;
            that.codeValue =  time + '秒';
            if (time == 0) {
                clearInterval(t);
                that.codeValue = '重新获取';
                that.validCode=true;
            }
        }
    },
    // 删除代理区域
    deleteAddress(e) {
        let info = e,
            _this = this;
        _this.userInfo.AreaList.forEach((element,index) => {
            if(info.AreaID == element.AreaID){
                _this.userInfo.AreaList.splice(index,1)
            }
        });
    },
    userRegisterClick() {
        let _this = this,
            userInfo = {};
        // let agentname = Number(String(_this.userInfo.AgentName).trim());
        let phone = String(_this.userInfo.Phone).trim();
        let linkman = String(_this.userInfo.Linkman);
        // let address =  String(_this.userInfo.Address);
        // if(!agentname) {
        //     _this.abp.api.reqSuccess(_this,'登录账号不能为空');
        //     return;
        // }else if(!/^1[34578]\d{9}$/.test(agentname)){
        //     _this.abp.api.reqSuccess(_this,'登录账号格式不正确');
        //     return;
        // }
        if(!phone) {
            _this.abp.api.reqSuccess(_this,'手机号不能为空');
            return;
        }else if(!/^1[34578]\d{9}$/.test(phone)){
            _this.abp.api.reqSuccess(_this,'手机号格式不正确');
            return;
        }
        if("" == linkman) {
            _this.abp.api.reqSuccess(_this,'姓名不能为空');
            return;
        }
        // if("" == address) {
        //     _this.abp.api.reqSuccess(_this,'可联系地址不能为空');
        //     return;
        // }
        // if(_this.userInfo.AreaList.length == 0) {
        //     _this.abp.api.reqSuccess(_this,'代理区域不能为空');
        //     return;
        // }
        userInfo = {
            // Password: 123456,
            // AgentName: phone,
            Linkman: linkman,
            Phone: phone,
            // Address: address,
            InvitationCode: _this.userInfo.InvitationCode,
            // AreaList: _this.userInfo.AreaList,
            Code: _this.userInfo.Code,
        }
        if(_this.userInfo.Code) {
            _this.$indicator.open('加载中...');
            _this.abp.api.PublicRegisterAgent(userInfo)
                .then((res)=> {
                    if(res.status == 200) {
                        if(res.data.IsSuccess) {
                            _this.$indicator.close();
                            _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                            sessionStorage.setItem('AuthorizationBearer',res.data.Data.Token);
                            sessionStorage.setItem('UserInfo',_this.abp.f_Base64.encode(JSON.stringify(res.data.Data.Agent)));
                            _this.abp.UserInfos.userInfo = res.data.Data.Agent;
                            _this.abp.UserInfos.userBearer = res.data.Data.Token;
                            _this.$router.replace( '/adduserinfo' );
                            // _this.$router.replace(this.$route.query.redirect || '/home' );
                        }else{
                            _this.$indicator.close();
                            if(res.data.OutputMessage == '用户微信信息验证错误'){
                                _this.abp.api.reqSuccess(_this,res.data.OutputMessage);
                                window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2ef8ae95cbbc8732&redirect_uri='+_this.requestUrl+'%23%2fregister&response_type=code&scope=snsapi_base#wechat_redirect'
                            }else if(res.data.OutputMessage == '未找到推荐人！'){
                                _this.$messagebox({
                                    title: '温馨提示',
                                    message: '邀请码不正确,请重新输入',
                                    showCancelButton: false,
                                    confirmButtonText:"确定"
                                }).then(action => {
                                    if(action == 'confirm'){
                                        localStorage.removeItem('userinviteCode');
                                        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2ef8ae95cbbc8732&redirect_uri='+_this.requestUrl+'%23%2fregister&response_type=code&scope=snsapi_base#wechat_redirect'
                                    }
                                })
                            }else{
                                _this.$messagebox({
                                    title: '温馨提示',
                                    message: res.data.OutputMessage,
                                    showCancelButton: false,
                                    confirmButtonText:"确定",
                                    cancelButtonText:"手误"
                                }).then(action => {
                                    if(action == 'confirm'){
                                        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2ef8ae95cbbc8732&redirect_uri='+_this.requestUrl+'%23%2fregister&response_type=code&scope=snsapi_base#wechat_redirect'
                                    }
                                })
                            }
                        }
                    }else {
                        _this.$indicator.close();
                    }
                })
                .catch((error)=> {
                    let _this = this;
                    _this.$indicator.close();
                    _this.abp.api.reqSuccess(this,error?_this.res.data.OutputMessage:'登录出错!')
                })
        }else{
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2ef8ae95cbbc8732&redirect_uri='+_this.requestUrl+'%23%2fregister&response_type=code&scope=snsapi_base#wechat_redirect'
        }
    }
  },
  mounted() {
    var clientHeight = document.body.clientHeight;
    var _focusElem = null;
    document.body.addEventListener("focus", function(e) {
        _focusElem = e.target || e.srcElement;
    }, true);
    window.addEventListener("resize", function() {
        if(_focusElem && document.body.clientHeight < clientHeight) {
            _focusElem.scrollIntoView(true);
        }
    }); 
    let _this = this,
        reg = new RegExp('(^|&)code=([^&]*)(&|$)');
    if(localStorage.getItem('userinviteCode')){
        _this.userInfo.InvitationCode = localStorage.getItem('userinviteCode');
    }
    _this.requestUrl = _this.abp.api.Hosts;
    let regUrl = window.location.search.substr(1).match(reg);
    if(regUrl != null) {
      _this.userInfo.Code = regUrl[2];
      _this.abp.api.reqSuccess(_this,'请五分钟内完成注册');
    }else{
        _this.userInfo.Code = '';
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2ef8ae95cbbc8732&redirect_uri='+_this.requestUrl+'%23%2fregister&response_type=code&scope=snsapi_base#wechat_redirect'
    }
  }
}
</script>

<style scoped>
    .user-register {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    .user-register .submit-btn {
        width: 80%;
        margin: auto;
        margin-top: 50px;
    }
</style>
